import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAuth } from '../../../context/AuthContext';

function UserRoleForm({ handleClose, handleRoleData }) {

  const { user } = useAuth();
  const { bid, businessProfile } = user.claims;

  const [roleData, setRoleData] = useState({
    email: '',
    password: '',
    displayName: '',
    claimConfig: {
      role: '',
      bid: bid,
      businessProfile: businessProfile
    }
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(event) {
    event.preventDefault();
    const { id, value } = event.target;
    setInputError(prevData => ({ ...prevData, [id]: '' }));
    setRoleData(prevData => ({ ...prevData, [id]: value }));
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const { email, password, displayName, claimConfig } = roleData;
    if (!displayName) {
      setInputError({ ...inputError, displayName: 'This field is required.' });
    } else if (claimConfig && !claimConfig.role) {
      setInputError({ ...inputError, role: 'This field is required.' });
    } else if (!email) {
      setInputError({ ...inputError, email: 'This field is required.' });
    } else if (!password) {
      setInputError({ ...inputError, password: 'This field is required.' });
    } else {
      handleRoleData(roleData);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='row mb-3'>
        <div className='col-md-8'>
          <Form.Group controlId='displayName'>
            <Form.Label>Display Name</Form.Label>
            <Form.Control
              placeholder='Alberto, Smith, Ellie etc.'
              onChange={handleChange}
              value={roleData.displayName}
              className={inputError && inputError.displayName ? 'border-danger' : ''}
              isInvalid={inputError && inputError.displayName}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.displayName}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-4'>
          <Form.Group className="mb-3" controlId="role">
            <Form.Label>Role *</Form.Label>
            <Form.Select
              onChange={(e) => {
                setRoleData({
                  ...roleData,
                  claimConfig: {
                    ...roleData.claimConfig,
                    role: e.target.value
                  },
                });
                setInputError({ ...inputError, role: '' })
              }}
              value={roleData && roleData.claimConfig && roleData.claimConfig.role}
              isInvalid={inputError && inputError.role}
            >
              <option value="">Select</option>
              <option value="manager">Manager</option>
              <option value="accountant">Accountant</option>
              <option value="associate">Associate</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">{inputError && inputError.role}</Form.Control.Feedback>
          </Form.Group>
        </div>
      </div>
      <div className='row mb-3'>
        <div className='col-md-6'>
          <Form.Group controlId='email'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='xyz@example.com'
              onChange={handleChange}
              value={roleData.email}
              className={inputError && inputError.email ? 'border-danger' : ''}
              isInvalid={inputError && inputError.email}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.email}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-6'>
          <Form.Group controlId='password'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='XXXX-XXXX-XXXX'
              onChange={handleChange}
              value={roleData.password}
              className={inputError && inputError.password ? 'border-danger' : ''}
              isInvalid={inputError && inputError.password}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.password}</Form.Control.Feedback>
          </Form.Group>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-between pt-3'>
        <Button
          variant="outline-danger"
          className='px-5 py-2'
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          variant="primary"
          className='px-5 py-2'
          type='submit'
        >
          Save
        </Button>
      </div>
    </Form>
  );
}

export default UserRoleForm;
